export default {
    login: {
        method: 'POST',
        url: process.env.VUE_APP_API_URL + '/auth/login'
    },
    federatedTokenLogin: {
        method: 'POST',
        url: process.env.VUE_APP_API_URL + '/auth/federated-token-login'
    },
    federatedEmailLogin: {
        method: 'POST',
        url: process.env.VUE_APP_API_URL + '/auth/federated-email-login'
    },
    logout: {
        method: 'GET',
        url: process.env.VUE_APP_API_URL + '/logout'
    },
    globalInit: {
        method: 'GET',
        url: process.env.VUE_APP_API_URL + '/global-init'
    },
    authenticatedInit: {
        method: 'GET',
        url: process.env.VUE_APP_API_URL + '/authenticated-init'
    },
    sendConfirmEmail: {
        method: 'POST',
        url: process.env.VUE_APP_API_URL + '/send-confirm-email',
    },
    confirmEmail: {
        method: 'POST',
        url: process.env.VUE_APP_API_URL + '/confirm-email',
    },
    newPassword: {
        method: 'POST',
        url: process.env.VUE_APP_API_URL + '/new-password',
    },
    validateResetToken: {
        method: 'GET',
        url: process.env.VUE_APP_API_URL + '/reset-token/valid/:token',
    },
    resetPassword: {
        method: 'POST',
        url: process.env.VUE_APP_API_URL + '/reset-password',
    },
    resetPasswordByUserId: {
        method: 'GET',
        url: process.env.VUE_APP_API_URL + '/reset-password/user/:userId'
    },
    updateProfile: {
        method: 'POST',
        url: process.env.VUE_APP_API_URL + '/profile/update'
    },
    pairAccount: {
        method: 'POST',
        url: process.env.VUE_APP_API_URL + '/pair-account'
    },
    pairAccountAdmin: {
        method: 'POST',
        url: process.env.VUE_APP_API_URL + '/pair-account-admin',
    },
    unpairedAccounts: {
        method: 'GET',
        url: process.env.VUE_APP_API_URL + '/unpaired-accounts',
    },
    unpairAccount: {
        method: 'POST',
        url: process.env.VUE_APP_API_URL + '/unpair-account',
    },
    activateAccount: {
        method: 'POST',
        url: process.env.VUE_APP_API_URL + '/activate-account',
    },
    deactivateAccount: {
        method: 'POST',
        url: process.env.VUE_APP_API_URL + '/deactivate-account',
    },
    mergeAccounts: {
        method: 'POST',
        url: process.env.VUE_APP_API_URL + '/merge-accounts',
    },
    shutItDown: {
        method: 'POST',
        url: process.env.VUE_APP_API_URL + '/shutItDown'
    },
    isInMaintenanceMode: {
        method: 'GET',
        url: process.env.VUE_APP_API_URL + '/isMaintenanceMode'
    },
    version:{
        method: 'GET',
        url: process.env.VUE_APP_API_URL + '/version'
    },
    get2FAStatus: {
        method: 'GET',
        url: process.env.VUE_APP_API_URL + '/user/2fa'
    },
    enableDisable2FA: {
        method: 'POST',
        url: process.env.VUE_APP_API_URL + '/user/2fa'
    },
}